// extracted by mini-css-extract-plugin
module.exports = {"claimRow":"ClaimChestRow_claimRow_39z2L","rowImg":"ClaimChestRow_rowImg_2UK5y"};